import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { APIService } from "@utils/apiService";
import { AppConfig } from "@config/config";
import { enqueueSnackbarMessage } from "@slices/commonSlice/common";
import { AxiosError } from "axios";

export interface TimebasedState {
  state: "failed" | "success" | "loading" | "idle";
  stateMessage: string | null;
  activeCycleId: string | null;
  successMessage: string | null;
}

const initialState: TimebasedState = {
  state: "idle",
  stateMessage: null,
  successMessage: null,
  activeCycleId: null
};

export const updateRecommendation = createAsyncThunk(
  "admin/updateRecommendation",
  async (
    payload: {
      id: number;
      statement: string;
      comment: string | null;
    },
    { dispatch },
  ) => {
    return new Promise<{
      successMessage: string
    }>((resolve, reject) => {
      APIService.getInstance()
        .patch<{ status: string }>(
          AppConfig.serviceUrls.savePromotionRecommendation,
          payload,
        )
        .then((resp) => {
           if (resp.status >= 200 && resp.status < 300){
            dispatch(
                enqueueSnackbarMessage({
                message:
                    String(resp.data.status),
                type: "success",
                }),
            );
           }
           resolve({
                successMessage: resp.data.status
           });
        })
        .catch((error: AxiosError) => {
          dispatch(
            enqueueSnackbarMessage({
              message:
                error.response?.status === 500
                  ? String(error.response?.data)
                  : "Unable to save the recommendation",
              type: "error",
            }),
          );
          reject(error);
        });
    });
  },
);

export const AdminTimebasedSlice = createSlice({
  name: "adminTimebased",
  initialState,
  reducers: {
    setCycleId: (state, action: PayloadAction<string | null>) => {
      state.activeCycleId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateRecommendation.pending, (state) => {
        state.stateMessage = "Loading Requests";
        state.state = "loading";
      })
      .addCase(updateRecommendation.fulfilled, (state, action) => {
        state.state = "success";
      })
      .addCase(updateRecommendation.rejected, (state, action) => {
        state.state = "failed";
      });
  },
});

export const { setCycleId } = AdminTimebasedSlice.actions;

export default AdminTimebasedSlice.reducer;
